// ============================================
// 设备消息窗口去重（防 history 回放 / 实时 data 双通道重复合并；
// 同一 key 在窗口期内只放行一次——重复合并会污染 aiEvents 事件流并触发 React 重复 key）
// ============================================

/** 创建去重器：key 在 windowMs 内重复出现返回 true；超限时先清理过期项、再按插入序淘汰最旧 */
export function createMessageDeduper(windowMs = 2000, limit = 300) {
  const seen = new Map<string, number>();
  return function isDuplicate(key: string, now: number = Date.now()): boolean {
    const last = seen.get(key);
    if (last !== undefined && now - last < windowMs) return true;
    seen.set(key, now);
    if (seen.size > limit) {
      for (const [k, t] of seen) {
        if (now - t >= windowMs) seen.delete(k);
      }
      while (seen.size > limit) {
        const first = seen.keys().next().value;
        if (first === undefined) break;
        seen.delete(first);
      }
    }
    return false;
  };
}
